import initialState from './initialState';
import { types } from '../actions/boardActions';

export default function boardThreadsReducer(state = initialState.boardThreads, action) {
  switch (action.type) {
    case types.GET_THREADS: {
      return { fetching: true, data: [] };
    }
    case types.GET_THREADS_SUCCESS: {
      const { data } = action;
      return { fetching: false, data, };
    }
    case types.GET_THREADS_FAILURE: {
      return { fetching: false, data: [] };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/boardThreadsReducer.js